// Exports
export default {
	"conferencesHistoryHeader": "conferencesHistoryHeader_3Nnl+",
	"top": "top_p6tHw",
	"left": "left_W1WwP",
	"privateRouteConferencesHistoryHeader": "privateRouteConferencesHistoryHeader_3hKut",
	"title": "title_la+px",
	"filter": "filter_5Wz+G",
	"dateFilter": "dateFilter_Dr70I",
	"monthsListBox": "monthsListBox_H2WlD",
	"divider": "divider_-26ek",
	"endSlot": "endSlot_Ela32"
};
